import { useApi } from '@gravitate-js/the-armory'
import { getAPIURL } from '@utils/api'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useOperationsRequests = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()
  const getOperationsRequestsQuery = (filters) =>
    useQuery({
      queryKey: ['operationsRequestsQuery', filters],
      queryFn: () =>
        api.post('operations_request/overview', undefined, {
          queryParams: new URLSearchParams(filters),
        }),
      enabled: !!filters,
    })

  const editRequestMutation = useMutation({
    mutationKey: ['editRequestMutation'],
    mutationFn: (request) => api.post(`operations_request/upsert`, request),
    onSuccess: async (response, request) => {
      await queryClient.invalidateQueries({
        queryKey: ['operationsRequestsQuery'],
      })
    },
  })

  const deleteRequestMutation = useMutation({
    mutationKey: ['deleteRequestMutation'],
    mutationFn: (request) =>
      api.post(`operations_request/delete`, undefined, {
        queryParams: new URLSearchParams({ operation_id: request }),
      }),
    onSuccess: async (response, request) => {
      queryClient.setQueriesData({ queryKey: ['operationsRequestsQuery'] }, (oldData) => {
        return {
          ...oldData,
          rows: oldData.rows.filter((row) => request !== row._id),
        }
      })
    },
  })

  return {
    getOperationsRequestsQuery,
    editRequestMutation,
    deleteRequestMutation,
  }
}
